import { generateSetChild, generateUpdateArrayChild, generateAddArrayChild } from '@/helpers/VuexHelpers'
import { contaoService } from '@/service';

export default {
	namespaced: true,
	state: {
		jobs: [],
	},
	actions: {
		async loadJobs({ commit }, { workAreas, canton, brand } = {}) {
			const result = await contaoService.jobs({ workAreas, canton, brand })
			commit('setJobs', { item: result })
		}
	},
	getters: {
		jobs(state) {
			return state.jobs
		},
		workAreas(state, getters) {
			return getters.jobs
				.reduce((a, j) => {
					return [
						...a,
						...j.workAreas.filter(wa => !a.find(aa => aa.id == wa.id))
					]
				}, [])
				.sort((a, b) => a.name.localeCompare(b.name))
		},
		cantons(state, getters) {
			return Array.from(new Set(getters.jobs
				.reduce((a, j) => {
					return [
						...a,
						j.canton
					]
				}, [])
				.sort((a, b) => a.localeCompare(b))
			))
		},
		regions(state, getters) {
			return Array.from(new Set(getters.jobs
				.reduce((a, j) => {
					return [
						...a,
						j.region
					]
				}, [])
				.sort((a, b) => a.localeCompare(b))
			))
		},
		brands(state, getters) {
			return Array.from(new Set(getters.jobs
				.reduce((a, j) => {
					return [
						...a,
						j.brand
					]
				}, [])
				.sort((a, b) => a.localeCompare(b))
			))
		}
	},
	mutations: {
		setJobs: generateSetChild("jobs"),
	}
}
